import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { viewerModel } from 'entities/viewer';
import { EDP_API_V1_URL } from 'shared/get-env';
import queryString from 'query-string';
import { clientCookies } from '../../../shared/lib';
import { RootState } from '../../store';
import { AuthLoginResponse } from './auth';

const baseQuery = fetchBaseQuery({
  baseUrl: EDP_API_V1_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).entities.viewer.credentials.token;
    if (token) headers.set('authorization', `Bearer ${token}`);
    return headers;
  },
  paramsSerializer: queryString.stringify,
});

const baseRefreshQuery = fetchBaseQuery({
  baseUrl: EDP_API_V1_URL,
  prepareHeaders: (headers, { getState }) => {
    const { refreshToken } = (getState() as RootState).entities.viewer.credentials;
    if (refreshToken) headers.set('authorization', `Bearer ${refreshToken}`);
    return headers;
  },
});

export const refreshTokenQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  const { dispatch } = api;
  let result = await baseQuery(args, api, extraOptions);
  const { error } = result;
  if (error && error.status === 401) {
    const { data } = await baseRefreshQuery({ method: 'POST', url: '/v1/admin/auth/refresh' }, api, extraOptions);
    if (data) {
      const { refreshToken, token, tokenTTL, refreshTokenTTL } = data as AuthLoginResponse;
      clientCookies.setCredentials({ token, refreshToken, tokenTTL, refreshTokenTTL });
      dispatch(viewerModel.credentials.actions.setCredentials({ token, refreshToken }));
      result = await baseQuery(args, api, extraOptions);
    } else {
      // логика выхода из приложения
      clientCookies.removeCredentials();
      dispatch(viewerModel.credentials.actions.reset());
    }
  }
  return result;
};
